/* Paulie Pocket - swipebare productfoto's op productkaarten (Claude, okt 2026) */
(function () {
  if (window.ppSwipeInit) return;
  window.ppSwipeInit = true;

  function go(root, dir) {
    var slides = root.querySelectorAll('.pp-swipe__slide');
    var n = slides.length;
    if (n < 2) return;
    var cur = parseInt(root.getAttribute('data-pp-index') || '0', 10);
    var next = (cur + dir + n) % n;
    root.setAttribute('data-pp-index', next);
    root.setAttribute('data-pp-moved', '');
    for (var i = 0; i < n; i++) slides[i].classList.toggle('is-active', i === next);
    var dots = root.querySelectorAll('.pp-swipe__dot');
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-active', k === next);
    // volgende foto alvast laden
    var pre = slides[(next + 1) % n].querySelector('img.lazyload');
    if (pre) pre.classList.add('lazypreload');
  }

  var sx = 0, sy = 0, root = null, swiped = false;

  document.addEventListener('touchstart', function (e) {
    root = e.target.closest ? e.target.closest('[data-pp-swipe]') : null;
    if (!root || e.touches.length !== 1) { root = null; return; }
    sx = e.touches[0].clientX;
    sy = e.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!root) return;
    var t = e.changedTouches[0];
    var dx = t.clientX - sx, dy = t.clientY - sy;
    if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.2) {
      go(root, dx < 0 ? 1 : -1);
      swiped = true;
      setTimeout(function () { swiped = false; }, 400);
    }
    root = null;
  }, { passive: true });

  document.addEventListener('click', function (e) {
    if (swiped && e.target.closest && e.target.closest('[data-pp-swipe]')) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    var arrow = e.target && e.target.closest ? e.target.closest('.pp-swipe__arrow') : null;
    if (!arrow) return;
    e.preventDefault();
    e.stopPropagation();
    go(arrow.closest('[data-pp-swipe]'), arrow.classList.contains('pp-swipe__arrow--prev') ? -1 : 1);
  }, true);
})();
